<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import PaymentTypesForm from './PaymentTypesForm.vue';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean  
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/finance/master-data/payment-types/'
const title = 'Payment Types'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields: TableField[] = [
  { name: 'icon_image', caption: 'Image', sortable: false, fieldType: 'image' },
  { name: 'code', caption: 'Code', sortable: true, fieldType: 'text' },
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'sort_order', caption: 'Sort Order', sortable: true, fieldType: 'number' },
  { name: 'shortcut', caption: 'Shortcut', sortable: true, fieldType: 'text' },
  { name: 'allow_over_tender', caption: 'Allow Over Tender', sortable: true, fieldType: 'boolean' },
  { name: 'allow_return', caption: 'Allow Return', sortable: true, fieldType: 'boolean' },
  { name: 'require_attachment', caption: 'Require Attachment', sortable: true, fieldType: 'boolean' },
  { name: 'require_customer', caption: 'Require Customer', sortable: true, fieldType: 'boolean' },
  { name: 'check_credit', caption: 'Check Credit', sortable: true, fieldType: 'boolean' },
  { name: 'require_verification', caption: 'Require Verification', sortable: true, fieldType: 'boolean' },
  { name: 'has_denomination', caption: 'Has Denomination', sortable: true, fieldType: 'boolean' },
  { name: 'issue_balance', caption: 'Issue Balance', sortable: true, fieldType: 'boolean' },
  { name: 'bank_charges_percent', caption: 'Bank Charges (%)', sortable: true, fieldType: 'number' },
  { name: 'is_system', caption: 'Is System', sortable: true, fieldType: 'boolean' },
  { name: 'require_reference', caption: 'Require Reference', sortable: true, fieldType: 'boolean' },
  { name: 'require_payment_for_delivery', caption: 'Require Payment for Delviery', sortable: true, fieldType: 'boolean' },
  { name: 'auto_generate_reference', caption: 'Auto Generate Reference', sortable: true, fieldType: 'boolean' },
  { name: 'read_ocr', caption: 'Read OCR', sortable: true, fieldType: 'boolean' },  
  { name: 'require_account', caption: 'Require Attachment', sortable: true, fieldType: 'boolean' },
  { name: 'active', caption: 'Active', sortable: false, fieldType: 'status' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const permissions = ref<Permission[]>([])
const handlePermissions = (perm: Permission[]) => {
  permissions.value = perm
}

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" @permissions="handlePermissions">
  <template #form-view>
    <PaymentTypesForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>